import React from "react";
import shipSink from "../../assets/images/error-404-ship.svg";
import CustomButton from "../../components/CustomButton/CustomButton";
import { useNavigate } from "react-router-dom";

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="w-[100vw] h-[100vh] flex flex-col items-center justify-center">
      <h1>ERROR 4🛟4</h1>
      <img width="500" src={shipSink} alt="ship-sink" />
      <div className="flex flex-col gap-4 items-center">
        <div className="flex flex-col items-center gap-2">
          <span className="text-[22px]">OOPS! You have sailed too far...</span>
          <span className="text-[18px]">Let us help you sail back to port</span>
        </div>
        <CustomButton onButtonClick={() => navigate('/')}>Return Home</CustomButton>
      </div>
    </div>
  );
};

export default NotFound;
